<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item active">
        <a href="javascript:;">商品品牌</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      商品品牌
      <small>定义商品品牌...</small>
    </h1>
    <!-- end page-header -->
    <panel title="商品品牌列表" :noButton="true">
      <div slot="heading-btn">
        <button type="button" class="btn btn-theme btn-sm" @click="fn_add_brand">
          <i class="fa fa-plus"></i> 新增品牌
        </button>
      </div>
      <Table border size="small" :columns="columns" :data="data">
        <template slot-scope="{ row } " slot="brand_logo">
          <img :src="logourl+row.brand_logo" style="max-height:100px" />
        </template>
        <template slot-scope="{row}" slot="site_url">
          <a :href="'http://' + row.site_url">{{row.site_url}}</a>
        </template>

        <template slot-scope="{row}" slot="is_show">
          <span v-if="row.is_show">显示</span>
          <span v-else>不显示</span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <button
            type="button"
            class="btn btn-theme btn-sm"
            style="margin-right: 5px"
            @click="fn_edit(row,index)"
          >修改</button>

          <Poptip
            transfer
            confirm
            title="是否要删除此品牌?"
            @on-ok="fn_remove(row,index)"
            ok-text="确认"
            cancel-text="取消"
          >
            <button type="button" class="btn btn-danger btn-sm">删除</button>
          </Poptip>
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="totalRows"
        :current="currentPage"
        :page-size="pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPage"
      />
    </panel>
    <Drawer title="商品品牌" v-model="v_edit_brand" width="720" :mask-closable="true">
      <Form :model="formData" ref="formData" :rules="rules" :labelWidth="120">
        <FormItem label="类型名称" label-position="top" prop="brand_name">
          <Input v-model="formData.brand_name" placeholder="商品分类名称" />
        </FormItem>
        <FormItem label="Logo">
          <Row :gutter="3">
            <Col span="7">
              <Upload
                name="filename"
                :show-upload-list="false"
                :action="uploadhost"
                :format="['jpg','jpeg','png']"
                :on-success="fn_uploadSuccess"
                :max-size="2048"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                style="display: inline-block;width:90px;"
              >
                <Button icon="ios-cloud-upload-outline">上传Logo</Button>
              </Upload>
            </Col>
            <Col span="14">
              <img :src="logourl+formData.brand_logo" style="max-height:100px" />
            </Col>
          </Row>
        </FormItem>

        <FormItem label="网址" label-position="top">
          <Input v-model="formData.site_url" placeholder="please enter url">
            <span slot="prepend">http://</span>
          </Input>
        </FormItem>

        <FormItem label="是否显示">
          <RadioGroup v-model="formData.is_show">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </RadioGroup>

          <small class="f-s-12 text-grey-darker">当品牌下还没有商品的时候，首页及分类页的品牌区将不会显示该品牌</small>
        </FormItem>

        <FormItem label="排序" label-position="top">
          <InputNumber v-model="formData.sortval" :min="0"></InputNumber>
        </FormItem>

        <FormItem label="品牌描述" label-position="top">
          <Input
            type="textarea"
            v-model="formData.brand_desc"
            :rows="6"
            placeholder="please enter the description"
          />
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <button
          type="button"
          class="btn btn-default"
          style="margin-right: 8px"
          @click="v_edit_brand = false"
        >关闭</button>
        <button type="button" class="btn btn-theme" @click="fn_store_data">保存</button>
      </div>
    </Drawer>
  </div>
</template>
<script>
import { storeBrandData, getBrandList, removeBrandData } from "@/api/goods";
import config from "@/config";
export default {
  data() {
    return {
      uploadhost: config.baseUrl.pro + "/upload/uploadfile",
      logourl: config.baseUrl.imageurl,
      columns: [
        {
          title: "分类名称",
          key: "brand_name",
          width: 150
        },
        {
          title: "品牌Logo",
          slot: "brand_logo",
          width: 120
        },
        {
          title: "网站",
          slot: "site_url",
          width: 200
        },
        {
          title: "是否显示",
          slot: "is_show",
          width: 120
        },
        {
          title: "排序",
          key: "sortval",
          width: 120
        },
        {
          title: "描述",
          key: "brand_desc"
        },
        {
          title: "操作",
          slot: "action",
          width: 200,
          align: "center"
        }
      ],
      data: [],
      formData: {
        id: 0,
        brand_name: "",
        brand_logo: "",
        brand_desc: "",
        site_url: "",
        sortval: 0,
        is_show: 0
      },
      rules: {
        brand_name: [
          {
            required: true,
            message: "名称必填",
            tirgger: "blur"
          }
        ]
      },
      v_edit_brand: false,
      totalRows: 0,
      pageNum: 10,
      currentPage: 1
    };
  },
  mounted() {
    let filterCond = {
      page: 1,
      pageNum: this.pageNum
    };
    this.fn_load_data(filterCond);
  },
  methods: {
    fn_load_data(filterCond) {
      getBrandList(filterCond).then(res => {
        this.data = res.data.data;
        this.totalRows = res.data.total;
      });
    },
    fn_switchPage(page) {
      this.currentPage = page;
      let filterCond = {
        page: page,
        pageNum: this.pageNum
      };
      this.fn_load_data(filterCond);
    },
    fn_add_brand() {
      this.v_edit_brand = true;
      this.formData = {
        id: 0,
        brand_name: "",
        brand_logo: "",
        brand_desc: "",
        site_url: "",
        sortval: 0,
        is_show: 0
      };
    },
    fn_edit(row, index) {
      this.formData = row;
      this.v_edit_brand = true;
    },

    fn_remove(row, index) {
      removeBrandData(row.id)
        .then(res => {
          if (res.data.code == 200) {
            this.data.splice(index, 1);
            this.$Notice.success({
              title: "成功",
              desc: res.data.message
            });
          } else {
            this.$Notice.error({
              title: "错误",
              desc: res.data.message
            });
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_store_data() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          storeBrandData(this.formData)
            .then(res => {
              if (res.data.code == 200) {
                this.v_edit_brand = false;
                if (this.formData.id == 0) this.data.push(res.data.data);
                this.$Notice.success(res.data);
              } else {
                this.$Notice.error(res.data);
              }
            })
            .catch(error => {
              this.$Message.error(error);
            });
        }
      });
    },
    fn_uploadSuccess(res, file) {
      if (file.response.code === 200) {
        this.formData.brand_logo = file.response.data;
      }
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc:
          "文件 " + file.name + " 格式不正确，请上传 jpg 或 png 格式的图片。"
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "超出文件大小限制",
        desc: "文件 " + file.name + " 太大，不能超过 2M。"
      });
    }
  }
};
</script>